import localStorage from './localStorage'

export const getUser = () => {
  const user = localStorage.getItem('user') || ''
  try {
    return JSON.parse(user)
  } catch {
    return {}
  }
}

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user))
}

export const updateUser = (params) => {
  const user = getUser()
  if (user) {
    localStorage.setItem('user', JSON.stringify({ ...user, ...params }))
  }
}

export const setUserSelectedFilters = (key, filtersData) => {
  localStorage.setItem(key, JSON.stringify(filtersData))
}

export const getUserSelectedFilters = (key) => {
  const filtersData = localStorage.getItem(key) || ''
  try {
    return JSON.parse(filtersData)
  } catch {
    return {}
  }
}
